<inthraction-objective-response-distribution [mode]="ObjectiveResponseDistributionMode.MANAGER"></inthraction-objective-response-distribution>
